module.exports = __webpack_public_path__ + "img/popup-btn-owner.0ba6494.png";